
import {FormattedMessage, injectIntl, defineMessages, IntlShape} from 'react-intl';
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import {IntlProvider} from 'react-intl';
import {getLocale} from '../locales';
import {getMessages} from '../getMessages';
import "./Registration.scss";
import Logo from '../app/Logo.react';
import {defaultOptions} from '../app/auth.js';
import Auth0Lock from 'auth0-lock';
import Auth0Variables from '../app/auth0-variables';
import {displayError} from '../app/errorDisplayer';
import initRelayLayer from '../initRelayLayer';
import MeQuery from '../queries/MeQuery';
import RelayQueryRequest from 'react-relay/lib/RelayQueryRequest';
import {Query} from 'react-relay/lib/fromGraphQL';
import EventTracker from '../app/EventTracker';
import Deferred from '../fw/deferred';
import fetch from 'node-fetch';
import FormData from 'form-data';
import {LoadingLine} from '../loadingLine/renderLoadingPanel.react';

/* eslint react/jsx-sort-props: 0 */

export const messages = defineMessages({
    newsletter: {id: 'registration.newsletter', 'defaultMessage': 'Receive monthly newsletter'},
    agree1: {id: 'registration.signupTerm1', 'defaultMessage': 'I agree to the'},
    agree2: {id: 'registration.signupTerm2', 'defaultMessage': 'license agreement'},
});

export function isRegistration() {
    if (window.location.pathname === '/signup' || window.location.pathname === '/registration') {
        return true;
    }
    return false;
}

export function init() {
    let finishedPromise = new Deferred();
    ReactDOM.render(
        <IntlProvider locale={getLocale()} messages={getMessages()}>
            <Registration />
        </IntlProvider>,
        document.getElementById('app')
    );

    return finishedPromise.promise;
}

interface Registration_Props {
 intl?: object;
}

class Registration_ extends React.Component<Registration_Props> {

    static propTypes = {
        intl: PropTypes.object,
    };

    constructor() {
        super();

        this.state = {
            step: 1,
            apps: "",
            newsletter: true,
            isFromLogin: window.location.hash.indexOf('#pathname') === 0,
            registered: false,
        };

        this.skipInstallStep = false;
    }

    getLogInPath() {
        let hash = window.location.hash || '';
        let path = hash.substring('#pathname='.length);

        return path || '/';
    }

    render() {
        return (
            <div className="Registration">
                <header><a href="https://www.dativery.com"><Logo color /></a></header>
                <h2><FormattedMessage defaultMessage="Sign Up" id="registration.topHeader" /></h2>
                {this.renderCreateAccount()}
                <footer>
                    <span><FormattedMessage defaultMessage="Already have an account?" id="login.withoutAccount" /> </span>
                    <a className="switch" href={this.getLogInPath()}>
                        <FormattedMessage defaultMessage="Log In" id="login.topHeader" />
                        <span><svg focusable="false" className="icon-text" width="8px" height="12px" viewBox="0 0 8 12" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g id="Web/Submit/Active" transform="translate(-148.000000, -32.000000)" fill="#FFFFFF"><polygon id="Shape" points="148 33.4 149.4 32 155.4 38 149.4 44 148 42.6 152.6 38"></polygon></g></g></svg></span>
                    </a>
                </footer>
            </div>
        );
    }

    initAuth() {
        let options = defaultOptions;
        options.container = 'authContainer';
        options.theme = {
            logo: undefined,
            primaryColor: '#12b100'
        };
        options.rememberLastLogin = false;
        options.auth = {
            responseType: 'token',
            redirect: false
        };
        options.mustAcceptTerms = true;
        options.languageDictionary.signUpTerms = this.props.intl.formatMessage(messages.agree1) + " <a href='https://www.dativery.com/" + getLocale() + "/terms/' target='_new'>" + this.props.intl.formatMessage(messages.agree2) + "</a>";
        options.allowLogin = false;

        let lock = new Auth0Lock(
            Auth0Variables.AUTH0_CLIENT_ID,
            Auth0Variables.AUTH0_DOMAIN,
            options
        );

        lock.show();

        let self = this;
        lock.on("authenticated", function(authResult) {
            EventTracker.trackEvent(EventTracker.EVENT_CLICKS, {
                event: 'authentication',
                type: 'application'
            });

            self.setState({
                registered: true
            });

            // Use the token in authResult to getProfile() and save it to localStorage
            lock.getProfile(authResult.accessToken, function(error, newProfile) {
                if (error) {
                    displayError(error);
                    return;
                }

                if (self.state.newsletter) {
                    self.newsletterSubscribe({
                        LANG: getLocale() === 'cs' ? 'cs' : 'en',
                        EMAIL: newProfile.email,
                        FNAME: newProfile.given_name,
                        LNAME: newProfile.family_name,
                    });
                }

                localStorage.setItem('profile', JSON.stringify(newProfile));
                localStorage.setItem('userToken', authResult.idToken);

                let RelayNetworkLayer = initRelayLayer();
                RelayNetworkLayer.sendQueries([new RelayQueryRequest(Query(MeQuery.user()))]).then(() => {
                    self.finishRegistrion();
                }).catch(() => {
                    localStorage.removeItem('profile');
                    localStorage.removeItem('userToken');
                });
            });
        });
    }

    getSubscribeLink() {
            return 'https://www.dativery.com/' + getLocale() + '/stay-informed-subscribe/';
    }

    getPrivacyLink() {
        return 'https://www.dativery.com/' + getLocale() + '/privacy/';
    }

    componentDidMount() {
        this.initAuth();
    }

    newsletterChange(event) {
        this.setState({
            newsletter: event.target.checked
        });
    }

    renderCreateAccount() {
        let isActive = true;

        return (
            <div className={"stepBox" + " step-1" + (isActive ? ' active' : '') + ' last' }>
                {this.state.registered ? (<LoadingLine />) : null}
                <div className="wrapper">
                    <div className="stepBody">
                        <div className="auth0-lock-input-checkbox"><label><input checked={this.state.newsletter} onChange={(e) => { this.newsletterChange(e); }} type="checkbox" /><span><FormattedMessage defaultMessage="Receive monthly newsletter" id="registration.receiveNewsletter" /></span></label></div>
                        <div id="authContainer"></div>
                    </div>
                </div>
            </div>
        );
    }

    newsletterSubscribe(params) {
        EventTracker.trackEvent(EventTracker.EVENT_CLICKS, {
            event: 'newsletter',
            type: 'application'
        });

        // formData being an object with your form data like:
        // { EMAIL: 'emailofyouruser@gmail.com' }

        let formData = new FormData();

        formData.append('email', params.EMAIL);
        formData.append('name', params.FNAME);
        formData.append('surname', params.LNAME);

        return fetch("https://dativery.ecomailapp.cz/public/subscribe/20/85f7dba955e715936a175d446bc6f115?source=app", {
            method: "POST",
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            body: formData,
        }).catch((e) => {
            console.error(e);
        });
    }

    finishRegistrion() {
        if (this.state.isFromLogin) {
            window.location = window.location.origin + decodeURI(window.location.hash.substring(10));
        }
        else {
            window.location = window.location.origin + '/s/';
        }
    }
}
let Registration = injectIntl(Registration_);
